import { render, staticRenderFns } from "./videoFullPlatform.vue?vue&type=template&id=33495a85&scoped=true&"
import script from "./videoFullPlatform.vue?vue&type=script&lang=js&"
export * from "./videoFullPlatform.vue?vue&type=script&lang=js&"
import style0 from "./videoFullPlatform.vue?vue&type=style&index=0&id=33495a85&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33495a85",
  null
  
)

export default component.exports